import type { TMessages } from '@/types/TMessages'

export const messages = {
  sign: 'Подберем индивидуальные условия. Расскажем обо всех подходящих продуктах от ВТБ',
  forAgrariansOnly: 'Доступно только для аграриев',
} satisfies TMessages
